(function () {
  if (window.__jhnySearchPromptsBooted) return;
  window.__jhnySearchPromptsBooted = true;

  var prompts = [
    "Find blue artwork",
    "Show me abstract art",
    "Find art for my bedroom",
    "Show me warm-toned artwork",
    "I want a square canvas",
    "Find a large horizontal artwork",
    "Show me Mediterranean-inspired art",
    "Find playful art for a colorful kitchen",
    "Show me calm art in soft neutral tones",
    "Find a bold statement piece for my living room",
    "I need artwork for the wall above my sofa",
    "Show me coastal art without looking too nautical",
    "Find a warm abstract piece for my dining room",
    "What artwork works in a minimalist bedroom?",
    "Show me blue and terracotta artwork",
    "Find art that works with a beige interior",
    "I want something joyful but still sophisticated",
    "Show me a pair of artworks for a gallery wall",
    "Find a vertical piece for a narrow wall",
    "Show me earthy artwork with organic shapes",
    "I need a calm canvas for my home office",
    "Find modern art with a Mediterranean mood",
    "Show me artwork that makes a white room feel warmer",
    "I want a colorful poster for a small apartment",
    "Find art for a room with dark wood furniture",
    "Show me pieces inspired by summer and the sea",
    "Help me choose art for above a console table",
    "Find a subtle statement piece in blue tones",
    "Show me art with architectural shapes",
    "I need a large canvas that feels peaceful",
    "Find artwork for a bright, modern kitchen",
    "Show me warm minimalism with a little color",
    "I want art that feels collected, not decorated",
    "Find a landscape artwork in earthy tones",
    "Show me a poster that brings energy to the room",
    "What art works with cream, oak and black accents?"
  ];

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var states = [];
  var scanQueued = false;

  function setPlaceholder(state, text) {
    if (!state.input.isConnected) return;
    state.input.setAttribute("placeholder", text);
  }

  function clearTimer(state) {
    if (!state.timer) return;
    window.clearTimeout(state.timer);
    state.timer = null;
  }

  function schedule(state, delay) {
    clearTimer(state);
    state.timer = window.setTimeout(function () {
      tick(state);
    }, delay);
  }

  function tick(state) {
    if (!state.input.isConnected) {
      clearTimer(state);
      return;
    }

    if (document.hidden) {
      schedule(state, 700);
      return;
    }

    if (state.input.value) {
      setPlaceholder(state, state.originalPlaceholder);
      state.character = 0;
      state.deleting = false;
      clearTimer(state);
      return;
    }

    var prompt = prompts[state.promptIndex % prompts.length];

    if (!state.deleting) {
      state.character += 1;
      setPlaceholder(state, prompt.slice(0, state.character));

      if (state.character >= prompt.length) {
        state.deleting = true;
        schedule(state, 1900);
      } else {
        schedule(state, 42 + Math.floor(Math.random() * 26));
      }
      return;
    }

    state.character -= 1;
    setPlaceholder(state, prompt.slice(0, Math.max(0, state.character)));

    if (state.character <= 0) {
      state.deleting = false;
      state.promptIndex = (state.promptIndex + 1) % prompts.length;
      schedule(state, 320);
    } else {
      schedule(state, 22 + Math.floor(Math.random() * 16));
    }
  }

  function bind(input) {
    if (!input || input.dataset.jhnySearchPromptReady === "true") return;
    input.dataset.jhnySearchPromptReady = "true";

    var originalPlaceholder = input.getAttribute("placeholder") || "Search";
    input.dataset.jhnyOriginalPlaceholder = originalPlaceholder;

    var state = {
      input: input,
      originalPlaceholder: originalPlaceholder,
      promptIndex: Math.floor(Math.random() * prompts.length),
      character: 0,
      deleting: false,
      timer: null
    };

    states.push(state);

    input.addEventListener("input", function () {
      if (input.value) {
        clearTimer(state);
        setPlaceholder(state, originalPlaceholder);
        state.character = 0;
        state.deleting = false;
      } else {
        state.promptIndex = (state.promptIndex + 1) % prompts.length;
        schedule(state, 420);
      }
    });

    input.addEventListener("search", function () {
      if (!input.value) schedule(state, 420);
    });

    if (reduceMotion) {
      setPlaceholder(state, prompts[state.promptIndex]);
      return;
    }

    schedule(state, 550 + Math.floor(Math.random() * 650));
  }

  function scan() {
    scanQueued = false;
    var inputs = document.querySelectorAll('input[type="search"][name="q"]');
    for (var i = 0; i < inputs.length; i++) bind(inputs[i]);
  }

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(scan);
  }

  function boot() {
    scan();

    var observer = new MutationObserver(queueScan);
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener("shopify:section:load", queueScan);
    document.addEventListener("visibilitychange", function () {
      if (document.hidden || reduceMotion) return;
      for (var i = 0; i < states.length; i++) {
        if (states[i].input.isConnected && !states[i].input.value) schedule(states[i], 180);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
